import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { WebcamImage } from 'ngx-webcam';
import { CameraComponent } from '../common/components/camera/camera.component';
import { LoaderService } from '../shared/services/common/loader/loader.service';
import { Selfie } from '../shared/models/selfie.model';
import { AppService } from '../shared/services/app/app.service';
import { LocalStoreService } from '../shared/services/common/local-store/local-store.service';
import { HttpClientModule } from '@angular/common/http';
import { Guid } from 'guid-typescript';
import { async } from 'rxjs/internal/scheduler/async';
//some change are done
declare var $: any;
declare var window: any;
// let security_Longitude: any;
// let security_Latitude: any;
// let security_City: any;
// let security_State: any;
// let security_Country: any;
let security_Redirect_Url: any;
let security_Guid: any;
// let security_IP: any;

@Component({
	selector: 'app-selfie',
	templateUrl: './selfie.component.html',
	styleUrls: ['./selfie.component.scss'],
})
export class SelfieComponent implements OnInit {
	public browserVersion: string;
	public browserName: string;
	public apiTime: number;
	showLoader: boolean = false;
	public guId: Guid;
	public isLoading: boolean = true;
	public webcamImage: string;

	public selfie: Selfie;
	public message: string;
	public Latitude: any;
	public Longitude: any;
	buttonReady = false;

	public success: boolean = false;

	public redirecting: boolean = false;

	@ViewChild('camera') camera: CameraComponent;

	public isLoggedIn: boolean = false;
	public isLocationCaptured: boolean = false;
	public isCapturingLocation: boolean = false;

	failureCounter: number;
	successCounter: any;
	apiHitCounter: any;
	City: any;
	State: any;
	country: any;

	public constructor(
		private appService: AppService,
		private localStore: LocalStoreService,
		private route: ActivatedRoute,
		private router: Router
	) {
		this.guId = Guid.create();
	}

	public ngOnInit(): void {
		var me = this;
		this.captureGeo();
		//Confirm token is received as query param
		this.route.queryParams.subscribe((params) => {
			params = me.toLowerParams(params);

			if (params['t']) {
				me.localStore.setDataOnLogin(params['t']);
				me.verifyAuth();
			} else {
				me.isLoggedIn = false;
				$('#wrd').modal('show');
			}
		});
		this.selfie = new Selfie();
		this.browserVersion = this.detectBrowserVersion();
		this.browserName = this.detectBrowserName();

		this.captureGeo();


	}
	async verifyAuth() {
		this.isLoggedIn = await this.appService.verifyAuth().toPromise();
	}
	// captureGeo() {
	// 	let me = this;

	// 	if (me.isLocationCaptured) {
	// 		console.log("Location already captured:", me.selfie.Latitude, me.selfie.Longitude);
	// 		return;
	// 	}

	// 	// Show "Capturing location..." message
	// 	me.isCapturingLocation = true;

	// 	console.log("Capturing location...");

	// 	if (navigator.geolocation) {
	// 		navigator.geolocation.getCurrentPosition(
	// 			(position: any) => {
	// 				me.selfie.Latitude = position.coords.latitude;
	// 				me.selfie.Longitude = position.coords.longitude;
	// 				this.Latitude = position.coords.latitude;
	// 				this.Longitude = position.coords.longitude;

	// 				me.isLocationCaptured = true;
	// 				me.isCapturingLocation = false; // Hide capturing message after success

	// 				console.log("Location Captured:", this.Latitude, this.Longitude);

	// 				$('#location-denied-modal').modal('hide');
	// 				$('#location-phone').modal('hide');
	// 			},
	// 			(error) => {
	// 				console.error("Error getting current position:", error);

	// 				me.isCapturingLocation = false; // Hide capturing message if failed

	// 				if (error.code === error.PERMISSION_DENIED) {
	// 					console.log("Location permission denied");
	// 					$('#location-denied-modal').modal('show');
	// 					$('#location-phone').modal('show');
	// 				} else if (error.code === error.TIMEOUT) {
	// 					console.log("Location request timed out. Please try again.");
	// 					// alert("Location request timed out. Please enable GPS and try again.");
	// 				} else {
	// 					console.log("Location unavailable. Please try again.");
	// 				}
	// 				this.isLoading = false;
	// 			},
	// 			{
	// 				enableHighAccuracy: false,  // Lower power consumption on mobile
	// 				timeout: 5000,  // Reduce timeout to 5 seconds
	// 				maximumAge: 10000  // Allow caching location for up to 10s
	// 			}
	// 		);
	// 	} else {
	// 		console.log("Geolocation not supported");
	// 		me.isCapturingLocation = false; // Hide capturing message
	// 		$('#location-denied-modal').modal('show');
	// 		$('#location-phone').modal('show');
	// 	}
	// }

captureGeo() {
		let me = this;
		me.isLocationCaptured = false;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position: any) => {
					// if (isIOS && isSafari) {
					// 	alert("IOS DETECTED")

					// Display the button if it's an iOS device using Safari
					// 	$('#safari').modal('show');
					// }
					me.selfie.Latitude = position.coords.latitude;
					me.selfie.Longitude = position.coords.longitude;
					me.isLocationCaptured = true;
					this.Latitude = position.coords.latitude;
					this.Longitude = position.coords.longitude;
					this.isLoading = false;
					console.log("LOCATION CAPTURED");
					$('#location-denied-modal').modal('hide');
					$('#location-phone').modal('hide');
					$('#location-Iphone').modal('hide');

					// if (!security_Redirect_Url) (
					// 	this.redirect_url_from_new_data()
					// )
				},
				(error) => {
					console.error("Error getting current position:", error);
					// Handle specific error conditions
					
					if (error.code === error.PERMISSION_DENIED) {
						console.log("Location permission denied");
						$('#location-denied-modal').modal('show');
						$('#location-phone').modal('show');
						// if (!security_Redirect_Url) (
						// this.redirect_url_from_new_data()
						// )
					}
					this.isLoading = false;
				},
				{
					enableHighAccuracy: false,
					timeout: 8000,
					maximumAge: 0
				}
			);
		} else {
			console.log("Geolocation not supported");
			$('#location-denied-modal').modal('show');
			$('#location-phone').modal('show');
			// Handle case where geolocation is not supported
			this.isLoading = false;
		}
	}

	capture() {
		this.isLoading = true;
		this.camera.toggleWebcam();
	}


	public getObjectFitSize = function (b, g, a, d, f) {
		var h = d / f
			, k = g / a;
		(b ? h > k : h < k) ? (b = g,
			k = b / h,
			d = f / k) : (k = a,
				b = k * h,
				d /= b);
		return {
			width: b,
			height: k,
			x: (b - g) * d / 2,
			y: (k - a) * d / 2,
			ratio: d
		}
	};

	// async pictureTaken(image: WebcamImage, browserName: any, browserVersion: any) {
	// 	let me = this;
	// 	let attemptCounter = 1; // Initialize the counter with 1
	// 	me.failureCounter = me.failureCounter || 0; // Retain failure counter across multiple invocations
	// 	me.apiHitCounter = me.apiHitCounter || 0; // Initialize apiHitCounter if not already done

	// 	this.webcamImage = image.imageAsDataUrl;
	// 	this.selfie.Image = image.imageAsBase64;
	// 	this.selfie.BrowserName = browserName;
	// 	this.selfie.BrowserVersion = browserVersion;

	// 	// Array of virtual camera names
	// 	const virtualCameraNames = ['altercam', 'virtual', 'vcam', 'camtwist', 'manycam virtual webcam', 'splitcam video driver', 'cyberlink youcam 10', 'obs-camera', 'obs-camera2', 'obs-camera3', 'obs-camera4'];
	// 	navigator.mediaDevices.enumerateDevices().then(devices => {
	// 		const virtualCameras = devices.filter(device => device.kind === 'videoinput' && virtualCameraNames.some(name => device.label.toLowerCase().includes(name)));

	// 		if (virtualCameras.length > 0) {
	// 			// Virtual camera detected
	// 			this.selfie.isVirtual = 1;
	// 		} else {
	// 			// No virtual camera detected
	// 			this.selfie.isVirtual = 0;
	// 		}

	// 		const videoEl = <HTMLVideoElement>self.document.getElementById("webcam");
	// 		let f = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];
	// 		const canvas = self.document.createElement("canvas");
	// 		canvas.width = parseInt(f.style.width);
	// 		canvas.height = parseInt(f.style.height);
	// 		let h = canvas.getContext("2d");
	// 		let k = parseInt(f.style.width),
	// 			l = parseInt(f.style.height),
	// 			m = this.getObjectFitSize(false, k, l, f.videoWidth, f.videoHeight);
	// 		h.drawImage(f, m.x, m.y, k * m.ratio, l * m.ratio, 0, 0, k, l);

	// 		// Increment the API hit counter
	// 		me.apiHitCounter++;

	// 		// Send the selfie data for analysis
	// 		this.appService.analyzeSelfie(this.selfie).subscribe(
	// 			(response) => {
	// 				const modifiedImage = canvas.toDataURL('image/png');
	// 				me.webcamImage = modifiedImage;
	// 				me.selfie.Image = modifiedImage;

	// 				// Transform fields in the response directly to uppercase
	// 				response.Latitude = response.latitude;
	// 				response.Longitude = response.longitude;
	// 				response.City = response.city;
	// 				response.Country = response.country;
	// 				response.State = response.state
	// 				response.timestamp = new Date().toISOString(); // Example format: "2025-01-31T14:30:45.123Z"


	// 				// Remove original lowercase keys
	// 				delete response.latitude;
	// 				delete response.longitude;
	// 				delete response.city;
	// 				delete response.country;
	// 				delete response.state

	// 				// Assign values to Selfie object
	// 				me.selfie.Latitude = response.Latitude;
	// 				me.selfie.Longitude = response.Longitude;
	// 				me.selfie.City = response.City;
	// 				me.selfie.Country = response.Country;
	// 				me.selfie.State = response.State

	// 				me.selfie.ApiHitCount = response.apiHitCounter

	// 				// Process the response
	// 				me.message = response.remark;
	// 				me.success = response.is_valid === 1;

	// 				me.camera.toggleWebcam();
	// 				$('#success-modal-camera').modal('show');

	// 				if (me.success) {
	// 					window.setTimeout(() => {
	// 						console.log(response , "this is response")
	// 						// Send the modified response
	// 						parent.postMessage(response, '*');
	// 					}, 3000);
	// 				} else {
	// 					// Logic for handling failure count if needed
	// 				}
	// 			},
	// 			(error) => {
	// 				me.camera.toggleWebcam();

	// 				// Handle errors
	// 				window.setTimeout(() => {
	// 					parent.postMessage({ error: 'An error occurred' }, '*');
	// 				}, 3000);
	// 			}
	// 		);

	// 	});
	// }


	async pictureTaken(image: WebcamImage, browserName: any, browserVersion: any,) {
		var me = this;
		// this.redirect_url_from_new_data()

		this.webcamImage = image.imageAsDataUrl;

		this.selfie.Image = image.imageAsBase64;
		this.selfie.BrowserName = browserName;
		this.selfie.BrowserVersion = browserVersion;
		// Array of virtual camera names
		const virtualCameraNames = [];

		navigator.mediaDevices.enumerateDevices().then(devices => {
			const virtualCameras = devices.filter(device => device.kind === 'videoinput' && virtualCameraNames.some(name => device.label.toLowerCase().includes(name)));

			if (virtualCameras.length > 0) {
				// Virtual camera detected
				this.selfie.isVirtual = 1;
			} else {
				// No virtual camera detected
				this.selfie.isVirtual = 0;
			}

			const videoEl = <HTMLVideoElement>self.document.getElementById("webcam")
			var f = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];
			const canvas = self.document.createElement("canvas");
			canvas.width = parseInt(f.style.width);
			canvas.height = parseInt(f.style.height);
			var h = canvas.getContext("2d");
			var k = parseInt(f.style.width),
				l = parseInt(f.style.height),
				m = this.getObjectFitSize(!1, k, l, f.videoWidth, f.videoHeight);
			// console.log(f.offsetHeight, f.offsetWidth)
			h.drawImage(f, m.x, m.y, k * m.ratio, l * m.ratio, 0, 0, k, l);


			this.appService.analyzeSelfie(this.selfie).subscribe(
				async (response) => {
					// console.log("Response from API:", response);

					const {
						latitude,
						longitude,
						city,
						country,
						state,
						...rest
					} = response;

					const modifiedImage = canvas.toDataURL('image/png');
					me.webcamImage = modifiedImage;
					me.selfie.Image = modifiedImage;
					me.message = response.remark;
					me.success = response.is_valid == 1;


					me.camera.toggleWebcam();
					$('#success-modal-camera').modal('show');

					if (me.success) {
						const securityData = {
							"city": city,
							"country": country,
							"state": state,
							"latitude": this.Latitude,
							"longitude": this.Longitude
						};
						const combinedData = {
							...rest,
							...securityData
						};
						console.log(combinedData, "THis is sombined data")
						// const modifiedImage = await	loadImageAndProcessImage(this.selfie.Image)

						// resolve(modifiedImage);

						window.setTimeout(function () {
							// window.location.reload()
							parent.postMessage(combinedData, '*');
						}, 3000);
					}





				},
				(error) => {
					this.camera.toggleWebcam();
				}
			);
		});
	}

	retry() {
		$('#success-modal-camera').modal('hide');
		this.camera.toggleWebcam();
	}

	reload() {
		window.location.reload()
	}
	// clickagainonsuccess() {
	// 	$('#success-modal-camera').modal('hide');
	// }
	//  async redirect_url_from_new_data() {
	// 	let current_token;
	// 	this.route.queryParams.subscribe((params) => {
	// 		params = this.toLowerParams(params);
	// 		current_token = params.t
	// 	});
	// 	var settings = {
	// 		"url": "https://7cuzheaz2i.execute-api.ap-south-1.amazonaws.com/default/liveliness_request_get",
	// 		"method": "POST",
	// 		"timeout": 0,
	// 		"headers": {
	// 		  "x-api-key": "nKq9Hvz8pI7LoqPLXyVIc5fza9BLpJDwaiHlZp6T",
	// 		  "Content-Type": "application/json"
	// 		},
	// 		"data": JSON.stringify({
	// 		  "token": current_token
	// 		}),
	// 	  };

	// 		await $.ajax(settings).done(function (response) {
	// 		security_Redirect_Url = response.redirect_url;
	// 	  });
	// }
	redirect() {
		$('#success-modal-camera').modal('hide');
		let me = this;
		if (me.redirecting) return;
		me.redirecting = true;
		me.appService.getRedirectUrl().subscribe(
			(response) => {
			},
			() => {
				me.redirecting = false;
			}
		);
	}

	toLowerParams(params: Params): Params {
		const lowerParams: Params = {};
		for (const key in params) {
			lowerParams[key.toLowerCase()] = params[key];
		}
		return lowerParams;
	}


	detectBrowserName() {
		this.selfie.BrowserName = this.browserName;
		let agent = window.navigator.userAgent.toLowerCase();
		switch (true) {
			case agent.indexOf('edga') > -1:
				return 'edge';
			case agent.indexOf('opr') > -1 && !!(<any>window).opr:
				return 'opera';
			case agent.indexOf("vivobrowser") > -1:
				return "vivobrowser";
			case agent.indexOf("samsungbrowser") > -1:
				return "samsungbrowser";
			case agent.indexOf("oppobrowser") > -1:
				return "oppobrowser";
			case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
				return 'chrome';
			case agent.indexOf('trident') > -1:
				return 'ie';
			case agent.indexOf('firefox') > -1:
				return 'firefox';
			case agent.indexOf('safari') > -1:
				return 'safari';
			default:
				return 'other';
		}
	}
	detectBrowserVersion() {
		this.selfie.BrowserVersion = this.browserVersion;
		var userAgent = navigator.userAgent,
			tem,
			matchTest =
				userAgent.match(
					/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
				) || [];

		if (/trident/i.test(matchTest[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
			return 'IE ' + (tem[1] || '');
		}
		if (matchTest[1] === 'Chrome') {
			tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
			if (tem != null)
				return tem.slice(1).join(' ').replace('OPR', 'Opera');
		}
		matchTest = matchTest[2]
			? [matchTest[1], matchTest[2]]
			: [navigator.appName, navigator.appVersion, '-?'];
		if ((tem = userAgent.match(/version\/(\d+)/i)) != null)
			matchTest.splice(1, 1, tem[1]);
		return matchTest.join(' ');
	}
}

